















import Vue from "vue";

// Import External Components
import Stage from "@miele/component-library-vue/src/components/content/hero/stage/Stage.vue";
import StageSlide from "@miele/component-library-vue/src/components/content/hero/stage/StageSlide.vue";

export default Vue.extend({
  name: "StageContainer",
  components: {
    Stage,
    StageSlide,
  },
  computed: {
    stageSlideItems() {
      return this.$store.getters.getFirstSlide;
    },
    translations() {
      return this.$store.state.translations;
    },
  },
  methods: {
    viewRecipe(slide: any, event: MouseEvent) {
      this.$router.push({
        name: "Detail",
        params: {
          id: slide.id,
          title: slide.headline,
        },
      });
      event.preventDefault();
    },
  },
});
